import axios from "axios";

export default {
  state: {
    venue_info: {
      id: null,
      name: "",
      images: [],
      terms_of_use: null
    },
    status: null,
    form: {
      addon_endtime: true,
      marketing_consent: true,
      discount_code: true
    },
    payment_methods: [
      {
        type: "",
        session_id: ""
      }
    ],
    be_payment_methods: [
      {
        type: "",
        session_id: ""
      }
    ],
    be_default_payment_method: '',
    events: [],
    localization: null,
    discount_code: "",
    premium_fee: 0,
    termsOfCancellation: null,
    has_intgr: false,
    expired: false,
    isCartLoading: false,
    cartError: null,
    isAddonsLoading: false,
    addonError: null,
    isTermsOfCancellationLoading: false,
    termsOfCancellationError: null,
    bedroomOptions: [],
    selectedAccommodation: [],
    dependentAddonError: false,
    treat_service_enquiry_as_free: false,
    airplus: {
      reasons: null,
      config: null
    },
    availability_id: null,
    applicable_layouts: [],
    optional_checkout_option_value: null,
    service_fee: 0
  },
  mutations: {
    loadCartSuccess(state, payload) {
      state.venue_info = payload.venue_info;
      state.status = payload.status;
      state.form = payload.form;
      state.payment_methods = payload.payment_methods;
      state.be_payment_methods = payload.be_payment_methods;
      state.be_default_payment_method = payload.be_default_payment_method;
      state.events = payload.events;
      state.localization = payload.localization;
      state.discount_code = payload.discount_code;
      state.premium_fee = payload.premium_fee;
      state.has_intgr = payload.has_intgr;
      state.expired = payload.expired;
      state.isCartLoading = false;
      state.cartError = null;
      state.treat_service_enquiry_as_free = payload.treat_service_enquiry_as_free;
      state.airplus = payload.airplus;
      state.availability_id = payload.availability_id;
      state.applicable_layouts = payload.applicable_layouts;
    },
    loadCartFail(state, payload) {
      state.cartError = payload;
      state.isCartLoading = false;
    },
    loadingCart(state) {
      state.isCartLoading = true;
    },
    editDiscount(state, payload) {
      state.discount_code = payload.code;
      state.events[0].price.total_price = payload.total_price;
      state.events[0].price.unit_price = payload.unit_price;
      state.events[0].price.type = payload.type;
      state.events[0].price.price_type = payload.price_type;
    },
    editPaymentMethods(state, payload){
      state.payment_methods = payload.payment_methods;
      state.be_payment_methods = payload.be_payment_methods;
      state.be_default_payment_method = payload.be_default_payment_method;
    },
    loadTermsOfCancellationSuccess(state, payload) {
      state.termsOfCancellation = payload;
      state.isTermsOfCancellationLoading = false;
      state.termsOfCancellationError = null;
    },
    loadTermsOfCancellationFail(state, payload) {
      state.isTermsOfCancellationLoading = false;
      state.termsOfCancellationError = payload;
    },
    loadingTermsOfCancellation(state) {
      state.isTermsOfCancellationLoading = true;
    },
    loadBedroomOptions(state, payload) {
      state.bedroomOptions = payload;
    },
    updateSelectedAccommodation(state, payload) {
      state.selectedAccommodation = payload;
    },
    setDependentAddonError(state, payload){
      state.dependentAddonError = payload
    },
    setCheckoutItemRoom(state, payload){
      state.events[0].room = payload
    },
    setOptionalCheckoutOptionValue(state, payload){
      state.optional_checkout_option_value = payload
    },
    setServiceFee(state, data) {
      state.service_fee = data
    },
  },
  actions: {
    async LOAD_CART({ commit }, { cartId }) {
      commit("loadingCart");
      let backendUrl = window.mp_api_url + "/v2/cart";
      try {
        const { data } = await axios.get(`${backendUrl}/${cartId}`);

        commit("loadCartSuccess", data);
        return data;
      } catch (error) {
        commit("loadCartFail", error);
      }
    },
    EDIT_PAYMENTMETHODS({ commit }, data) {
      commit("editPaymentMethods", data);
    },
    async LOAD_TERMS_OF_CANCELLATIONS({ commit }, { cartId, lang, amount, isPayOnSite }) {
      commit("loadingTermsOfCancellation");
      try {
        const { data } = await axios.post(
          `${window.mp_url_settings['BASE_URL']}/apiv2/${lang}/cart/${cartId}/cancelation-terms`, 
          {
            amount: amount,
            isPayOnSite: isPayOnSite
          }
        );
        commit("loadTermsOfCancellationSuccess", data);
        return data;
      } catch (error) {
        commit("loadTermsOfCancellationFail", error);
      }
    },
    EDIT_DISCOUNT({ commit }, payload) {
      commit("editDiscount", payload);
    },
    async LOAD_BEDROOM_OPTIONS({ commit }, payload) {
      try {
        const { data } = await axios.get(
          `${window.mp_url_settings['BASE_URL']}/apiv2/accommodation/index/${payload.venue_id}`
        );
        commit("loadBedroomOptions", data);
      } catch (error) {
      }
    },
    SET_DEPENDENT_ADDON_ERROR({commit}, payload) {
      commit('setDependentAddonError', payload)
    }
  }
};
